import { useState } from "react";
import { wishSubmissionSchema } from "../../schemas/wishes-schema";
import { resolveAssetPath } from "../../shared/utilities/assets";
import { getYoutubeId } from "../../shared/utilities/youtube";
import type { SectionRenderProps } from "../renderer/types";

export function WishesSection({ data, config, copy, services, wishes, refreshWishes }: SectionRenderProps) {
  const [feedback, setFeedback] = useState("");
  const [videoOpen, setVideoOpen] = useState(false);
  if (!data.wishes.enabled) return null;
  const youtubeUrl = String(config.settings.youtubeUrl || "");
  const videoId = getYoutubeId(youtubeUrl);
  const thumbnail = String(config.settings.youtubeThumbnail || "");
  return (
    <section className="wishes section-inner" id="wishes">
      <div className="section-heading"><p className="eyebrow">{copy.warmWishes}</p><h2 data-editor-section="wishes" data-editor-field="wishes.title">{data.wishes.title}</h2><p className="section-copy" data-editor-section="wishes" data-editor-field="wishes.description">{data.wishes.description}</p></div>
      <div className="wishes-layout">
        <form className="form-panel" onSubmit={async (event) => {
          event.preventDefault();
          const form = event.currentTarget;
          const result = wishSubmissionSchema.safeParse(Object.fromEntries(new FormData(form)));
          if (!result.success) { setFeedback("Please complete the wishes form."); return; }
          await services.wishes.submit(result.data);
          await refreshWishes();
          setFeedback(copy.wishSuccess);
          form.reset();
        }}>
          <label><span>{copy.name}</span><input type="text" name="name" required /></label>
          <label><span>{copy.wishesLabel}</span><textarea name="message" rows={5} required /></label>
          <div className="emoji-picker" aria-label="Emoticons">
            {data.wishes.emojiOptions.map((emoji) => <button key={emoji} type="button" onClick={(event) => {
              const form = event.currentTarget.form;
              const textarea = form?.elements.namedItem("message") as HTMLTextAreaElement | null;
              if (textarea) textarea.value += emoji;
            }}>{emoji}</button>)}
          </div>
          <button className="primary-btn dark-btn" type="submit">{copy.sendWish}</button>
          {feedback ? <p className="form-feedback show success" role="status">{feedback}</p> : null}
        </form>
        <div className="wish-list" aria-live="polite">
          {wishes.length ? wishes.slice(0, 40).map((wish) => <article className="wish-item" key={wish.id}><h3>{wish.name}</h3><p>{wish.message}</p></article>) : <p className="wish-empty">{copy.emptyWishes}</p>}
        </div>
      </div>
      {videoId ? <div className="wishes-video">
        {videoOpen ? <iframe src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`} title="Wedding wishes video" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen /> : <button className="youtube-cover" type="button" onClick={() => setVideoOpen(true)} aria-label="Play wedding video"><img src={resolveAssetPath(thumbnail)} alt="Wedding video" /><span className="youtube-play" /></button>}
      </div> : null}
    </section>
  );
}
